import { Controller } from "@hotwired/stimulus"

// Prevents double-submission by disabling the submit button on form submit.
// Use on forms that redirect immediately (e.g. Stripe checkout).
export default class extends Controller {
  static targets = ["submit"]

  submit() {
    this.submitTargets.forEach(btn => {
      btn.disabled = true

      // input[type=submit] carries its label in value, button_to's <button> in its text.
      if (btn.tagName === "BUTTON") {
        btn.textContent = "Redirecting..."
      } else {
        btn.value = "Redirecting..."
      }
    })
  }
}
